import { createSelector } from 'reselect';

const getAuthRoot = state => state.auth;

export const getAuthenticatedOnServer = createSelector(
  getAuthRoot,
  auth => auth.authenticatedOnServer,
);
